import { Routes } from '@angular/router';

import { customerAuthGuard } from './core/guards/customer-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/site-shell.component').then((m) => m.SiteShellComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/marketing/pages/landing-page.component').then((m) => m.LandingPageComponent),
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./features/marketing/pages/about-page.component').then((m) => m.AboutPageComponent),
      },
      {
        path: 'redeem',
        loadComponent: () =>
          import('./features/marketing/pages/redeem-hub-page.component').then((m) => m.RedeemHubPageComponent),
      },
      {
        path: 'how-it-works',
        loadComponent: () =>
          import('./features/marketing/pages/how-it-works-page.component').then((m) => m.HowItWorksPageComponent),
      },
      {
        path: 'brands',
        loadComponent: () =>
          import('./features/marketing/pages/merchants-list-page.component').then(
            (m) => m.MerchantsListPageComponent,
          ),
      },
      {
        path: 'brands/:merchantId',
        loadComponent: () =>
          import('./features/marketing/pages/merchant-detail-page.component').then(
            (m) => m.MerchantDetailPageComponent,
          ),
      },
      {
        path: 'campaigns/:campaignId/redeem/success',
        loadComponent: () =>
          import('./features/marketing/pages/redemption-success-page.component').then(
            (m) => m.RedemptionSuccessPageComponent,
          ),
      },
      {
        path: 'campaigns/:campaignId/redeem',
        loadComponent: () =>
          import('./features/marketing/pages/campaign-redeem-page.component').then(
            (m) => m.CampaignRedeemPageComponent,
          ),
      },
      {
        path: 'campaigns/:campaignId',
        loadComponent: () =>
          import('./features/marketing/pages/campaign-detail-page.component').then(
            (m) => m.CampaignDetailPageComponent,
          ),
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./features/marketing/pages/contact-page.component').then((m) => m.ContactPageComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./features/marketing/pages/register-page.component').then((m) => m.RegisterPageComponent),
      },
      {
        path: 'sign-in',
        loadComponent: () =>
          import('./features/marketing/pages/sign-in-shell.component').then((m) => m.SignInShellComponent),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/marketing/pages/sign-in-page.component').then((m) => m.SignInPageComponent),
          },
          {
            path: 'otp',
            loadComponent: () =>
              import('./features/marketing/pages/sign-in-otp-page.component').then((m) => m.SignInOtpPageComponent),
          },
        ],
      },
      {
        path: 'profile',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('./features/marketing/pages/customer-profile-page.component').then(
            (m) => m.CustomerProfilePageComponent,
          ),
      },
      {
        path: 'earn-points',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('./features/marketing/pages/earn-points-page.component').then((m) => m.EarnPointsPageComponent),
      },
      {
        path: 'discount-vouchers',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('./features/marketing/pages/info-placeholder-page.component').then(
            (m) => m.InfoPlaceholderPageComponent,
          ),
        data: { heading: 'My Discount Vouchers' },
      },
      {
        path: 'virtual-stamp-cards',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('./features/marketing/pages/virtual-stamp-cards-page.component').then(
            (m) => m.VirtualStampCardsPageComponent,
          ),
      },
      {
        path: 'settings',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('./features/marketing/pages/info-placeholder-page.component').then(
            (m) => m.InfoPlaceholderPageComponent,
          ),
        data: { heading: 'Settings' },
      },
      {
        path: 'business',
        redirectTo: 'brands',
        pathMatch: 'full',
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./features/marketing/pages/info-placeholder-page.component').then(
            (m) => m.InfoPlaceholderPageComponent,
          ),
        data: { heading: 'Privacy Policy' },
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./features/marketing/pages/info-placeholder-page.component').then(
            (m) => m.InfoPlaceholderPageComponent,
          ),
        data: { heading: 'Terms & Conditions' },
      },
      {
        path: 'help',
        loadComponent: () =>
          import('./features/marketing/pages/info-placeholder-page.component').then(
            (m) => m.InfoPlaceholderPageComponent,
          ),
        data: { heading: 'Help Center' },
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
